module.exports = __webpack_public_path__ + "img/kibe.4fe83741.png";